import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

const URL = '/v2/job-hidden-sitters';

interface JobHiddenSitter {
  id?: number;
  jobId: number;
  sitterId: number;
}

class JobHiddenSitterService {
  static hide(
    jobId: number,
    sitterId: number,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<JobHiddenSitter>> {
    return axios.post(URL, { jobId, sitterId }, config);
  }

  static unhide(
    id: number,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { JobHiddenSitterService };
